export default __webpack_public_path__ + "static/media/diabloBG.3f06f1bb.jpg";